module.exports = __webpack_public_path__ + "static/waveimaging-map-banner-5f92063d52e72e2baf136e7cc7296b38.jpg";